import React, { useState, useEffect } from 'react';

const API = '';

export default function B2BManagementPage({ user }) {
  const [companies, setCompanies] = useState([]);
  const [chargers, setChargers] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [showAdd, setShowAdd] = useState(false);
  const [form, setForm] = useState({ name: '', contact_name: '', contact_email: '', contact_phone: '', address: '', yearly_fee: '', per_kwh_rate: '0.35' });
  const [empEmail, setEmpEmail] = useState('');
  const [empRole, setEmpRole] = useState('employee');
  const [assignCharger, setAssignCharger] = useState('');
  const [chargerSearch, setChargerSearch] = useState('');
  const [companyChargers, setCompanyChargers] = useState([]);
  const [usage, setUsage] = useState(null);
  const [tab, setTab] = useState('details');

  const downloadCSV = (sessions) => {
    const csv = 'Employee,Email,Date,Charger,Energy (kWh),Cost\n' + (sessions||[]).map(s => {
      return [s.first_name+' '+s.last_name, s.email||'', new Date(s.start_time).toLocaleDateString(), s.charger_name||'', parseFloat(s.energy_consumed||0).toFixed(1), parseFloat(s.total_cost||0).toFixed(2)].join(',');
    }).join('\n');
    const blob = new Blob([csv], {type:'text/csv'});
    const a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = 'usage-report.csv'; a.click();
  };

  const headers = { 'Authorization': 'Bearer ' + localStorage.getItem('authToken'), 'Content-Type': 'application/json' };

  useEffect(() => { loadCompanies(); loadChargers(); }, []);

  const loadCompanies = async () => {
    const res = await fetch(API + '/api/b2b/companies', { headers });
    const data = await res.json();
    if (data.success) setCompanies(data.companies || []);
  };

  const loadChargers = async () => {
    const res = await fetch(API + '/api/chargers', { headers });
    const data = await res.json();
    setChargers(data.chargers || []);
  };

  const selectCompany = async (c) => {
    setSelectedCompany(c);
    setTab('details');
    const [empRes, chRes, usRes] = await Promise.all([
      fetch(API + '/api/b2b/companies/' + c.id + '/employees', { headers }),
      fetch(API + '/api/b2b/companies/' + c.id + '/chargers', { headers }),
      fetch(API + '/api/b2b/companies/' + c.id + '/usage', { headers }),
    ]);
    const empData = await empRes.json(); setEmployees(empData.employees || []);
    const chData = await chRes.json(); setCompanyChargers(chData.chargers || []);
    const usData = await usRes.json(); setUsage(usData);
  };

  const createCompany = async (e) => {
    e.preventDefault();
    const res = await fetch(API + '/api/b2b/companies', { method: 'POST', headers, body: JSON.stringify(form) });
    const data = await res.json();
    if (data.success) { setShowAdd(false); setForm({ name: '', contact_name: '', contact_email: '', contact_phone: '', address: '', yearly_fee: '', per_kwh_rate: '0.35' }); loadCompanies(); }
    else alert(data.error);
  };

  const addEmployee = async () => {
    if (!empEmail.trim()) return;
    const res = await fetch(API + '/api/b2b/companies/' + selectedCompany.id + '/employees', { method: 'POST', headers, body: JSON.stringify({ email: empEmail, role: empRole }) });
    const data = await res.json();
    if (data.success) { setEmpEmail(''); selectCompany(selectedCompany); }
    else alert(data.error);
  };

  const removeEmployee = async (id) => {
    if (!window.confirm('Remove this employee?')) return;
    await fetch(API + '/api/b2b/companies/' + selectedCompany.id + '/employees/' + id, { method: 'DELETE', headers });
    selectCompany(selectedCompany);
  };

  const addChargerToCompany = async () => {
    if (!assignCharger) return;
    await fetch(API + '/api/b2b/companies/' + selectedCompany.id + '/chargers', { method: 'POST', headers, body: JSON.stringify({ charger_id: parseInt(assignCharger) }) });
    setAssignCharger('');
    selectCompany(selectedCompany);
  };

  const removeCharger = async (chargerId) => {
    if (!window.confirm('Remove this charger from the company?')) return;
    await fetch(API + '/api/b2b/companies/' + selectedCompany.id + '/chargers/' + chargerId, { method: 'DELETE', headers });
    selectCompany(selectedCompany);
  };

  if (selectedCompany) {
    return (
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <button onClick={() => setSelectedCompany(null)} className="text-sm text-gray-500 hover:text-gray-700 mb-1">← Back to companies</button>
            <h2 className="text-2xl font-bold text-gray-800">{selectedCompany.name}</h2>
          </div>
          <div className="flex gap-2">
            <a href={'https://portal.lmpenergy.co.uk'} target="_blank" rel="noreferrer" className="px-4 py-2 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700">Open Company Portal →</a>
            <button onClick={async () => { if(window.confirm('Delete '+selectedCompany.name+'? This will remove all employee access.')) { await fetch(API+'/api/b2b/companies/'+selectedCompany.id, {method:'DELETE',headers}); setSelectedCompany(null); loadCompanies(); }}} className="px-4 py-2 bg-red-600 text-white rounded-lg text-sm font-medium hover:bg-red-700">Delete Company</button>
          </div>
        </div>

        <div className="grid grid-cols-4 gap-4">
          <div className="bg-white p-4 rounded-xl shadow-sm"><p className="text-xs text-gray-500">Employees</p><p className="text-2xl font-bold">{selectedCompany.employee_count}</p></div>
          <div className="bg-white p-4 rounded-xl shadow-sm"><p className="text-xs text-gray-500">Chargers</p><p className="text-2xl font-bold">{selectedCompany.charger_count}</p></div>
          <div className="bg-white p-4 rounded-xl shadow-sm"><p className="text-xs text-gray-500">Energy (30d)</p><p className="text-2xl font-bold">{usage?.total_energy?.toFixed(1) || 0} kWh</p></div>
          <div className="bg-white p-4 rounded-xl shadow-sm"><p className="text-xs text-gray-500">Revenue (30d)</p><p className="text-2xl font-bold text-green-600">£{usage?.total_cost?.toFixed(2) || '0.00'}</p></div>
        </div>

        <div className="flex space-x-1 bg-gray-100 p-1 rounded-lg">
          {['details', 'employees', 'chargers', 'usage'].map(t => (
            <button key={t} onClick={() => setTab(t)} className={`flex-1 py-2 text-sm font-medium rounded-md ${tab === t ? 'bg-white shadow-sm text-gray-800' : 'text-gray-500'}`}>
              {t.charAt(0).toUpperCase() + t.slice(1)}
            </button>
          ))}
        </div>

        {tab === 'details' && (
          <div className="bg-white rounded-xl p-6 shadow-sm">
            <div className="flex justify-between items-center mb-4">
              <h3 className="font-semibold text-lg">Company Details</h3>
              <button onClick={() => { setTab('edit'); setForm({name: selectedCompany.name, contact_name: selectedCompany.contact_name||'', contact_email: selectedCompany.contact_email||'', contact_phone: selectedCompany.contact_phone||'', address: selectedCompany.address||'', yearly_fee: selectedCompany.yearly_fee||'', per_kwh_rate: selectedCompany.per_kwh_rate||'0.35'}); }} className="px-3 py-1.5 bg-blue-600 text-white rounded-lg text-sm">Edit</button>
            </div>
            <div className="grid grid-cols-2 gap-4 text-sm">
              <div><span className="text-gray-500">Contact:</span> <span className="font-medium">{selectedCompany.contact_name}</span></div>
              <div><span className="text-gray-500">Email:</span> <span className="font-medium">{selectedCompany.contact_email}</span></div>
              <div><span className="text-gray-500">Phone:</span> <span className="font-medium">{selectedCompany.contact_phone}</span></div>
              <div><span className="text-gray-500">Address:</span> <span className="font-medium">{selectedCompany.address}</span></div>
              <div><span className="text-gray-500">Billing:</span> <span className="font-medium">{selectedCompany.billing_type}</span></div>
              <div><span className="text-gray-500">Yearly Fee:</span> <span className="font-medium">£{parseFloat(selectedCompany.yearly_fee || 0).toFixed(2)}</span></div>
              <div><span className="text-gray-500">Rate:</span> <span className="font-medium">£{parseFloat(selectedCompany.per_kwh_rate || 0).toFixed(4)}/kWh</span></div>
              <div><span className="text-gray-500">Since:</span> <span className="font-medium">{new Date(selectedCompany.created_at).toLocaleDateString()}</span></div>
            </div>
          </div>
        )}

        {tab === 'edit' && (
          <form onSubmit={async (e) => { e.preventDefault(); const res = await fetch(API+'/api/b2b/companies/'+selectedCompany.id, {method:'PUT',headers,body:JSON.stringify(form)}); const data = await res.json(); if(data.success){loadCompanies();selectCompany({...selectedCompany,...form});setTab('details');} else alert(data.error||'Failed'); }} className="bg-white rounded-xl p-6 shadow-sm space-y-4">
            <h3 className="font-semibold text-lg">Edit Company</h3>
            <div className="grid grid-cols-2 gap-4">
              <input value={form.name} onChange={e=>setForm({...form,name:e.target.value})} placeholder="Company name" className="px-3 py-2 border rounded-lg text-sm" />
              <input value={form.contact_name} onChange={e=>setForm({...form,contact_name:e.target.value})} placeholder="Contact name" className="px-3 py-2 border rounded-lg text-sm" />
              <input value={form.contact_email} onChange={e=>setForm({...form,contact_email:e.target.value})} placeholder="Email" className="px-3 py-2 border rounded-lg text-sm" />
              <input value={form.contact_phone} onChange={e=>setForm({...form,contact_phone:e.target.value})} placeholder="Phone" className="px-3 py-2 border rounded-lg text-sm" />
              <input value={form.address} onChange={e=>setForm({...form,address:e.target.value})} placeholder="Address" className="col-span-2 px-3 py-2 border rounded-lg text-sm" />
              <input value={form.yearly_fee} onChange={e=>setForm({...form,yearly_fee:e.target.value})} placeholder="Yearly fee" className="px-3 py-2 border rounded-lg text-sm" />
              <input value={form.per_kwh_rate} onChange={e=>setForm({...form,per_kwh_rate:e.target.value})} placeholder="Rate/kWh" className="px-3 py-2 border rounded-lg text-sm" />
            </div>
            <div className="flex gap-2">
              <button type="submit" className="px-6 py-2 bg-green-600 text-white rounded-lg text-sm font-medium">Save</button>
              <button type="button" onClick={()=>setTab('details')} className="px-6 py-2 border rounded-lg text-sm">Cancel</button>
            </div>
          </form>
        )}

        {tab === 'employees' && (
          <div className="bg-white rounded-xl p-6 shadow-sm">
            <h3 className="font-semibold text-lg mb-4">Employees</h3>
            <div className="flex gap-2 mb-4">
              <input value={empEmail} onChange={e => setEmpEmail(e.target.value)} placeholder="Employee email address" className="flex-1 px-3 py-2 border rounded-lg text-sm" />
              <select value={empRole} onChange={e => setEmpRole(e.target.value)} className="px-3 py-2 border rounded-lg text-sm">
                <option value="employee">Employee</option>
                <option value="admin">Admin</option>
              </select>
              <button onClick={addEmployee} className="px-4 py-2 bg-green-600 text-white rounded-lg text-sm font-medium">Add</button>
            </div>
            <p className="text-xs text-gray-400 mb-4">Employee must have an LMPEnergy app account first.</p>
            <table className="w-full text-sm">
              <thead><tr className="border-b"><th className="text-left py-2 text-gray-500">Name</th><th className="text-left py-2 text-gray-500">Email</th><th className="text-left py-2 text-gray-500">Role</th><th className="text-left py-2 text-gray-500">Status</th><th></th></tr></thead>
              <tbody>
                {employees.filter(e => e.status === 'active').map(e => (
                  <tr key={e.id} className="border-b">
                    <td className="py-3">{e.first_name} {e.last_name}</td>
                    <td className="py-3">{e.email}</td>
                    <td className="py-3"><span className={`px-2 py-0.5 rounded text-xs font-medium ${e.role === 'admin' ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-600'}`}>{e.role}</span></td>
                    <td className="py-3"><span className={`px-2 py-0.5 rounded text-xs font-medium ${e.status === 'active' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>{e.status}</span></td>
                    <td className="py-3 text-right"><button onClick={() => removeEmployee(e.id)} className="text-red-500 hover:text-red-700 text-xs">Remove</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {tab === 'chargers' && (
          <div className="bg-white rounded-xl p-6 shadow-sm">
            <h3 className="font-semibold text-lg mb-4">Assigned Chargers</h3>
            <div className="flex gap-2 mb-4">
              <div className="flex-1 relative">
                <input value={chargerSearch} onChange={e => { setChargerSearch(e.target.value); setAssignCharger(''); }} placeholder="Search charger by name or location..." className="w-full px-3 py-2 border rounded-lg text-sm" />
                {chargerSearch && !assignCharger && (
                  <div className="absolute z-10 w-full bg-white border rounded-lg shadow-lg mt-1 max-h-48 overflow-y-auto">
                    {chargers.filter(ch => !companyChargers.find(cc => cc.id === ch.id) && (ch.name.toLowerCase().includes(chargerSearch.toLowerCase()) || ch.location?.toLowerCase().includes(chargerSearch.toLowerCase()))).map(ch => (
                      <button key={ch.id} onClick={() => { setAssignCharger(String(ch.id)); setChargerSearch(ch.name + ' — ' + (ch.location||'')); }} className="w-full text-left px-3 py-2 hover:bg-gray-50 text-sm border-b">
                        {ch.name} — {ch.location}
                      </button>
                    ))}
                  </div>
                )}
              </div>
              <button onClick={addChargerToCompany} className="px-4 py-2 bg-green-600 text-white rounded-lg text-sm font-medium">Assign</button>
            </div>
            <div className="grid grid-cols-2 gap-3">
              {companyChargers.map(ch => (
                <div key={ch.id} className="border rounded-lg p-4">
                  <div className="flex justify-between items-start">
                    <div>
                      <p className="font-semibold">{ch.name}</p>
                      <p className="text-xs text-gray-500">{ch.location}</p>
                      <p className="text-xs mt-1">{ch.power_rating}kW · {ch.connector_type}</p>
                    </div>
                    <button onClick={() => removeCharger(ch.id)} className="text-red-400 hover:text-red-600 text-xs">Remove</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {tab === 'usage' && (
          <div className="bg-white rounded-xl p-6 shadow-sm">
            <div className="flex justify-between items-center mb-4">
              <h3 className="font-semibold text-lg">Usage Report — Last 30 Days</h3>
              <button onClick={() => downloadCSV(usage?.sessions)} className="px-3 py-1.5 bg-green-600 text-white rounded-lg text-sm font-medium">Download CSV</button>
            </div>
            <div className="grid grid-cols-3 gap-4 mb-6">
              <div className="bg-gray-50 p-3 rounded-lg"><p className="text-xs text-gray-500">Sessions</p><p className="text-xl font-bold">{usage?.total_sessions || 0}</p></div>
              <div className="bg-gray-50 p-3 rounded-lg"><p className="text-xs text-gray-500">Energy</p><p className="text-xl font-bold">{usage?.total_energy?.toFixed(1) || 0} kWh</p></div>
              <div className="bg-gray-50 p-3 rounded-lg"><p className="text-xs text-gray-500">Revenue</p><p className="text-xl font-bold text-green-600">£{usage?.total_cost?.toFixed(2) || '0.00'}</p></div>
            </div>
            <table className="w-full text-sm">
              <thead><tr className="border-b"><th className="text-left py-2 text-gray-500">Employee</th><th className="text-left py-2 text-gray-500">Date</th><th className="text-left py-2 text-gray-500">Charger</th><th className="text-left py-2 text-gray-500">Energy</th><th className="text-left py-2 text-gray-500">Cost</th></tr></thead>
              <tbody>
                {(usage?.sessions || []).map((s, i) => (
                  <tr key={i} className="border-b">
                    <td className="py-2">{s.first_name} {s.last_name}</td>
                    <td className="py-2">{new Date(s.start_time).toLocaleDateString()}</td>
                    <td className="py-2">{s.charger_name}</td>
                    <td className="py-2">{parseFloat(s.energy_consumed || 0).toFixed(1)} kWh</td>
                    <td className="py-2">£{parseFloat(s.total_cost || 0).toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold text-gray-800">B2B Companies</h2>
        <button onClick={() => setShowAdd(!showAdd)} className="px-4 py-2 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700">
          {showAdd ? 'Cancel' : '+ Add Company'}
        </button>
      </div>

      {showAdd && (
        <form onSubmit={createCompany} className="bg-white rounded-xl p-6 shadow-sm space-y-4">
          <h3 className="font-semibold text-lg">New Company</h3>
          <div className="grid grid-cols-2 gap-4">
            <input required value={form.name} onChange={e => setForm({...form, name: e.target.value})} placeholder="Company name" className="px-3 py-2 border rounded-lg text-sm" />
            <input value={form.contact_name} onChange={e => setForm({...form, contact_name: e.target.value})} placeholder="Contact name" className="px-3 py-2 border rounded-lg text-sm" />
            <input value={form.contact_email} onChange={e => setForm({...form, contact_email: e.target.value})} placeholder="Contact email" className="px-3 py-2 border rounded-lg text-sm" />
            <input value={form.contact_phone} onChange={e => setForm({...form, contact_phone: e.target.value})} placeholder="Phone" className="px-3 py-2 border rounded-lg text-sm" />
            <input value={form.address} onChange={e => setForm({...form, address: e.target.value})} placeholder="Address" className="col-span-2 px-3 py-2 border rounded-lg text-sm" />
            <input value={form.yearly_fee} onChange={e => setForm({...form, yearly_fee: e.target.value})} placeholder="Yearly fee (£)" className="px-3 py-2 border rounded-lg text-sm" />
            <input value={form.per_kwh_rate} onChange={e => setForm({...form, per_kwh_rate: e.target.value})} placeholder="Rate per kWh (£)" className="px-3 py-2 border rounded-lg text-sm" />
          </div>
          <button type="submit" className="px-6 py-2 bg-green-600 text-white rounded-lg text-sm font-medium">Create Company</button>
        </form>
      )}

      <div className="grid gap-4">
        {companies.map(c => (
          <div key={c.id} onClick={() => selectCompany(c)} className="bg-white rounded-xl p-5 shadow-sm hover:shadow-md transition-shadow cursor-pointer">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="font-semibold text-lg">{c.name}</h3>
                <p className="text-sm text-gray-500">{c.contact_name} · {c.contact_email}</p>
              </div>
              <div className="flex gap-6 text-center">
                <div><p className="text-xl font-bold">{c.employee_count}</p><p className="text-xs text-gray-400">Employees</p></div>
                <div><p className="text-xl font-bold">{c.charger_count}</p><p className="text-xs text-gray-400">Chargers</p></div>
                <div><p className="text-xl font-bold text-green-600">£{parseFloat(c.per_kwh_rate || 0).toFixed(2)}</p><p className="text-xs text-gray-400">/kWh</p></div>
              </div>
            </div>
          </div>
        ))}
        {companies.length === 0 && <p className="text-center text-gray-400 py-12">No companies yet. Click "Add Company" to get started.</p>}
      </div>
    </div>
  );
}
